import { Component } from 'macguffin'

/**
 * Waiting for connection will show after not getting a request for 5 seconds. 
 */
export default class WaitForConnection extends Component {
  /**
   * Render method will render out the overlay and text as a DOM element.
   * @returns {*}
   */
  render() {
    return (
      <div className={'waitingForConnection'}>
        <div className={'overlay'} />
        <h1>
          {this.t('error.waitingForConnection')}
        </h1>
      </div>
    )
  }
}
